<template>
    <ons-toolbar ref="toolbar">
        <div class="left">
            <ons-back-button v-show="showMenu && pageStackCount"
                @click="popPageStack"
                class="back-button">
                <span class="back-button__icon">
                    <img src="../../assets/icons/back-button.svg">
                </span>
                <span class="back-button__label"></span>
            </ons-back-button>
        </div>
        <div class="right">
            <ons-toolbar-button
                v-show="showMenu"
                modifier="material"
                @click="$store.commit('splitter/toggle')">
                <ons-icon icon="md-menu" class="ons-icon zmdi zmdi-menu menu-icon">
                    <span v-if="hasNotification" class="notification-dot"></span>
                </ons-icon>
            </ons-toolbar-button>
        </div>
        <div class="header center">{{ title }}</div>
    </ons-toolbar>
</template>
<script>
import Utils from '../mixins/Utils'
import Module from '../mixins/Module'

export default {
    data () {
        return {

        }
    },

    mixins: [
        Utils,
        Module('notifications'),
    ],

    props: ['title', 'name', 'path', 'showMenu', 'pageStack'],

    mounted() {

    },

    watch: {
        showMenu: {
            handler(newVal) {
                this.$nextTick(() => {
                    document.querySelector('ons-toolbar').setVisibility(newVal);
                });
            },
            immediate: true,
        }
    },

    computed: {
        hasNotification() {
            return _.get(this.notifications, 'content.data.length', 0)
        },

        pageStackCount() {
            return _.get(this.pageStack, 'length');
        },
    },

    methods: {
        popPageStack(e) {
            e.preventDefault()
            this.$emit('back', _.last(this.pageStack))
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    text-align: center;
}

img {
    max-width: 300px;
}

ons-list-title {
    text-transform: none;
}

ons-list-title:not(:first-of-type) {
    margin-top: 30px;
}

ons-card {
    text-align: center;
}

ons-list-item, ons-card {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Header.vue